export enum ChargeTypes {
  braintree = 'braintree',
  recharge = 'charge_braintree_recharge',
  payLater = 'charge_later',
  'Credit Card' = 'credit-card',
  'Gift Card' = 'charge_gift_card',
}
